import config from './config';
import util from '../util';
import env from '../env';
import isPlainObject from 'lodash-es/isPlainObject';
import { openMiddlePage } from './utils/helpers';

export const canGetInstallState = true;

let qqapiready = false;

export function ready() {
  return new Promise((resolve) => {
    if (qqapiready) {
      resolve();
    } else {
      util.loadScript(
        'qqapi',
        '//open.mobile.qq.com/sdk/qqapi.js?_bid=152',
        () => {
          qqapiready = true;
          resolve();
        },
      );
    }
  });
}

export async function getInstallState(conf = config) {
  await ready();
  return new Promise((resolve) => {
    const value = env.isIphone ? conf.packageUrl : conf.packageName;
    if (mqq.app.isAppInstalled) {
      mqq.app.isAppInstalled(value, (installed) => {
        if (isPlainObject(installed)) {
          resolve(installed.result);
        } else {
          resolve(installed);
        }
      });
    } else {
      mqq.invoke(
        'app',
        'isAppInstalled',
        {
          name: value,
        },
        (installed) => {
          resolve(installed);
        },
      );
    }
  });
}

export async function launch(schemeUrl) {
  await ready();
  window.location.href = schemeUrl;
  return true;
}

export async function download(conf = config) {
  const isOpenAppPage = openMiddlePage();
  // 只有 openapp 中间页才拉起下载
  if (!isOpenAppPage) return;

  if (env.isIos) {
    mqq.app.launchApp(conf.download);
  } else if (env.isAndroid) {
    window.location.href = `http://a.app.qq.com/o/simple.jsp?pkgname=${conf.packageName}`;
  }
}

export default {
  canGetInstallState,
  ready,
  getInstallState,
  launch,
  download,
};
